<ul class="nav flex-column pmd-sidebar-nav">
    <ng-container *ngIf="canShowMobileSubmenu">
        <ng-container *ngFor="let menu of options">
            <li class="nav-item"
                routerLinkActive="active">
                <a class="nav-link d-flex gap-2"
                    quicklink
                    [routerLink]="menu.path || null"
                    [routerLinkActive]="menu.path ? 'active' : ''"
                    (click)="closeSidebar()">
                    <span class="flex-grow-1"
                        *ngIf="menu.name"
                        aria-hidden="true">{{menu.name}}</span>
                </a>
            </li>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="!canShowMobileSubmenu">
        <ng-container *ngFor="let menu of options">
            <li class="nav-item"
                routerLinkActive="active">
                <a class="nav-link d-flex gap-2"
                    quicklink
                    [routerLink]="menu.path || null"
                    [routerLinkActive]="menu.path ? 'active' : ''">
                    <span><i class="pmd-nav-item-icon"
                            aria-hidden="true"
                            *ngIf="menu.svg"
                            [innerHTML]="menu.svg | safeHtml">

                        </i></span>
                    <span class="flex-grow-1"
                        *ngIf="menu.name"
                        aria-hidden="true">{{menu.name}}</span>
                </a>
            </li>
        </ng-container>
    </ng-container>
</ul>